/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type trialEnd_QueryVariables = {};
export type trialEnd_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"trialEnd_viewer">;
    } | null;
};
export type trialEnd_Query = {
    readonly response: trialEnd_QueryResponse;
    readonly variables: trialEnd_QueryVariables;
};



/*
query trialEnd_Query {
  viewer {
    actualPersonId
    component(name: "trial_end")
    ...trialEnd_viewer
    id
  }
}

fragment trialEnd_viewer on Viewer {
  id
  actualPersonId
  company {
    id
    tier
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "trial_end"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"trial_end\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "trialEnd_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "trialEnd_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "trialEnd_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tier",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "trialEnd_Query",
    "operationKind": "query",
    "text": "query trialEnd_Query {\n  viewer {\n    actualPersonId\n    component(name: \"trial_end\")\n    ...trialEnd_viewer\n    id\n  }\n}\n\nfragment trialEnd_viewer on Viewer {\n  id\n  actualPersonId\n  company {\n    id\n    tier\n  }\n}\n"
  }
};
})();
(node as any).hash = '40946ccda43af95e5feea2b5137e97cd';
export default node;
